import React, { useState, useEffect, useMemo } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import OnboardingForm from "./pages/OnboardingForm"; // 👈 import
import ForgotPassword from "./pages/ForgotPassword"; // 👈 import
import { Toaster } from "./components/ui/sonner";
import ViewDetails from "./pages/ViewDetails";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [user, setUser] = useState(null);
  const [newuser, setnewUser] = useState(false);
  const [memoizedUser, setmemoizedUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogin = (token, userData, comment) => {
    setToken(token);
    setUser(userData);
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));

    // Set flag for onboarding redirection
    if (comment === "new_user") {
      setnewUser(true);
    } else {
      setnewUser(false);
    }
  };

  const handleLogout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Login Route */}
          <Route
            path="/login"
            element={
              token ? (
                newuser ? (
                  <Navigate to="/onboardingForm" />
                ) : (
                  <Navigate to="/dashboard" />
                )
              ) : (
                <LoginPage onLogin={handleLogin} />
              )
            }
          />

          {/* Dashboard Route */}
          <Route
            path="/dashboard"
            element={
              token && user ? (
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          {/* Onboarding Form Route */}
          <Route path="/onboardingForm" element={<OnboardingForm />} />

          <Route path="/reset-password" element={<ForgotPassword />} />

          <Route path="/profile/:id" element={<ViewDetails />} />

          {/* Default Route (no newuser check) */}
          <Route
            path="/"
            element={<Navigate to={token ? "/dashboard" : "/login"} />}
          />
        </Routes>
      </BrowserRouter>

      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
